module.exports = __webpack_public_path__ + "img/icon_linkedin.svg?version=32f549d4";